<script setup lang='ts'>
const appConfig = useRuntimeConfig().public;

const footerText = appConfig.APP_CUSTOMER.footer_text;

const logoImageUrl = useLogoUrl();
const customerName = computed(() => appConfig.APP_CUSTOMER.name);
const footer_links = computed(() => appConfig.APP_CUSTOMER.footer_links as FooterLink[]);

const footer_social_links = {
  facebookUrl: appConfig.APP_CUSTOMER.social.url_facebook,
  xUrl: appConfig.APP_CUSTOMER.social.url_x,
  instagramUrl: appConfig.APP_CUSTOMER.social.url_instagram,
  mailUrl: appConfig.APP_CUSTOMER.social.url_email,
  googlePlayUrl: appConfig.APP_CUSTOMER.social.url_google_play_store,
  appStoreUrl: appConfig.APP_CUSTOMER.social.url_app_store,
  youtubeUrl: appConfig.APP_CUSTOMER.social.url_youtube,
  tikTokUrl: appConfig.APP_CUSTOMER.social.url_tik_tok,
};
</script>

<template>
  <BaseFooter
    :logo-image-url="logoImageUrl"
    :links="footer_links"
    :social-links="footer_social_links"
    :customer-name="customerName"
    :is-theme-switcher-shown="false"
    :footer-text="footerText"
  />
</template>
